import { dimensionValueStore } from "../../../../store/dimension.value";

import type { BaseDataSourceConfiguration, DataSource } from ".";

export type DimensionsData = { [key in string]: string };

export interface DimensionDataSourceConfiguration
    extends BaseDataSourceConfiguration {
    type: DataSource.DIMENSIONS;
    settings: DimensionDataSourceSettings;
}

export interface DimensionDataSourceSettings {
    ids: string[];
}
export const getDimensions = async (
    settings: DimensionDataSourceSettings,
): Promise<DimensionsData> => {
    const data = dimensionValueStore
        .getState()
        .getDimensionsValuesMapped(settings.ids);
    return data;
};
